export default {
  syncSetting: {
    // 导航标签
    navTabs: {
      all: '全部',
      basicData: '基础资料',
      customer: '客商中心',
      contractSync: '合同同步',
      system: '系统设置',
      freight: '超级运价',
      order: '订单中心',
      ehr: 'EHR对接',
      docControl: '文控资料'
    },

    // 同步卡片
    syncCards: {
      seaport: {
        title: '同步海港',
        description: '同步海港基础资料数据信息'
      },
      airport: {
        title: '同步空港',
        description: '同步空港基础资料数据信息'
      },
      route: {
        title: '同步航线',
        description: '同步航线基础资料数据信息'
      },
      chargeItem: {
        title: '同步费用项目',
        description: '同步费用项目基础资料数据信息'
      },
      inquiry: {
        title: '同步询价单',
        description: '同步客户询价单据和报价请求'
      },
      quotation: {
        title: '同步报价单',
        description: '同步报价单据和价格信息'
      },
      price: {
        title: '同步运价',
        description: '同步运价数据和费用标准信息'
      },
      order: {
        title: '同步订单',
        description: '同步订单信息和物流跟踪数据'
      },
      task: {
        title: '同步任务',
        description: '同步任务处理信息'
      },
      workflow: {
        title: '同步工作流',
        description: '同步工作流节点配置'
      },
      surcharge: {
        title: '同步附加费',
        description: '同步运价附加费信息信息'
      },
      user: {
        title: '同步员工列表',
        description: '同步企业员工信息和组织架构数据'
      },
      client: {
        title: '同步合作伙伴',
        description: '同步合作伙伴信息,包括供应商、客户等基础数据'
      },
      supplierEvaluation: {
        title: '同步供应商评价',
        description: '同步供应商评价数据和评分信息'
      }
    },

    // 按钮和操作
    actions: {
      editConfig: '编辑配置',
      cancel: '取消',
      confirm: '确定'
    },

    // 模态框
    modal: {
      editConfig: '编辑配置',
      syncPlatform: '同步平台',
      syncMode: '同步模式',
      selectPlatform: '请选择同步平台',
      selectMode: '请选择同步模式',
      fileSyncEnabled: '启用 X→CW 文件同步',
      fileSyncDocumentType: '目标文件类型',
      fileSyncDocumentTypePlaceholder: '空 = 空白文件类型'
    },

    // 消息提示
    messages: {
      configSaved: '配置已保存',
      configSaveSuccess: '配置保存成功',
      configSaveFailed: '保存配置失败',
      configNotFound: '未找到配置项',
      loadConfigFailed: '加载配置失败'
    },

    // 日志消息
    logs: {
      startInitConfig: '开始初始化配置详情',
      cannotGetTenantId: '无法获取当前租户ID，跳过初始化',
      configDefsCount: '配置定义列表',
      configDetailsCount: '配置详情列表',
      needCreateConfigs: '需要创建',
      configsToCreate: '需要创建的配置',
      configCreated: '已创建配置',
      configCreateFailed: '创建配置失败',
      configInitComplete: '配置初始化完成',
      noInitNeeded: '无需初始化配置',
      initConfigFailed: '初始化配置失败',
      loadAllConfigs: '加载所有配置',
      syncSwitchStatus: '同步开关状态',
      syncDetailConfig: '同步详细配置',
      saveConfig: '保存配置',
      switchChangeHandle: '开关变化处理',
      switchConfigUpdated: '开关配置已更新',
      detailConfigUpdated: '详细配置已更新',
      detailConfigName: '详细配置名称'
    }
  },

  ehr: {
    syncTimes: '同步时间',
    syncTimesPlaceholder: '组织/岗位 08:00,18:00；员工 00:00,03:00…每3小时',
    dingtalkTitle: '钉钉配置',
    dingtalkNotification: '启用工作通知',
    appKey: 'AppKey',
    appSecret: 'AppSecret',
    agentId: 'AgentId',
    testConnection: '测试连接',
    testSuccess: '钉钉连接成功',
    syncDingtalkUserId: '补全钉钉userId',
    syncDingtalkUserIdSuccess: '完成：成功 {success}，跳过 {skip}，失败 {fail}',
    configSaved: '配置已保存',
    cards: {
      organization: {
        title: '组织同步',
        description: '从 IAM 同步分公司/组织数据'
      },
      department: {
        title: '部门同步',
        description: '从 IAM 同步部门树数据'
      },
      position: {
        title: '岗位同步',
        description: '从 IAM 同步岗位主数据'
      },
      employee: {
        title: '员工同步',
        description: '从 IAM 同步员工账号信息'
      }
    },
    positionPage: {
      keyword: '关键词',
      keywordPlaceholder: '编码/名称',
      search: '查询',
      code: '编码',
      name: '名称',
      department: '部门',
      family: '岗位族',
      level: '级别',
      status: '状态'
    }
  },

  docControl: {
    cardTitle: '文控资料同步',
    cardDescription: '从 TMS 文控平台同步证书/报告文档元数据',
    syncTimes: '同步时间',
    syncTimesPlaceholder: '00:00,12:00,18:00',
    configSaved: '文控同步配置已保存',
    statusPartial: '部分成功'
  },

  supplierContract: {
    cardTitle: '供应商合同同步',
    cardDescription: '从韶音一诺合同系统（OC）同步供应商合同头、详情和文件信息',
    syncTimes: '同步时间点',
    status: '同步状态',
    lastSyncAt: '最后同步时间',
    totalCount: '记录 {count}',
    successCount: '成功 {count}',
    failureCount: '失败 {count}',
    syncNow: '立即同步',
    initialStartDate: '首次同步日期',
    initialStartDatePlaceholder: '请选择首次同步日期',
    connectionStatus: 'OC 连接状态',
    connectionConfigured: '已配置',
    connectionNotConfigured: '未配置',
    connectionNotice: 'OC 地址和账号密钥由 Nacos 管理，请先联系后端完成连接配置。',
    syncTimesPlaceholder: '例如：08:00,18:00',
    syncTimesInvalid: '同步时间格式不正确，请按 HH:mm 填写，多个时间用逗号分隔',
    syncTimesRequired: '开启定时同步前，请先设置同步时间',
    configSaved: '供应商合同同步配置已保存',
    saveFailed: '供应商合同同步配置保存失败',
    loadFailed: '供应商合同同步配置加载失败',
    syncSubmitted: '供应商合同同步任务已提交',
    syncFailed: '供应商合同同步失败',
    logTitle: '供应商合同同步日志',
    allStatuses: '全部状态',
    batchId: '批次号',
    triggerType: '触发方式',
    triggerManual: '手动',
    triggerScheduled: '定时',
    windowStart: '同步窗口开始时间',
    windowEnd: '同步窗口结束时间',
    total: '总数',
    success: '成功数',
    failure: '失败数',
    startedAt: '开始时间',
    finishedAt: '结束时间',
    duration: '耗时',
    durationValue: '{value} 毫秒',
    errorCode: '错误码',
    errorMessage: '错误信息',
    diagnosticDetails: '诊断明细',
    pageNumber: '页码',
    pageSize: '每页数量',
    latestCondition: '最新版条件',
    statusCondition: '状态条件',
    departmentCondition: '归属部门条件',
    ocReturned: 'OC 返回总数',
    pageReturned: '本页返回数',
    localAccepted: '本地通过数',
    actuallySaved: '实际保存数',
    noDiagnosticDetails: '暂无诊断明细',
    logLoadFailed: '供应商合同同步日志加载失败'
  },

  syncBar: {
    lastSync: '上次同步',
    recordCount: '共 {count} 条',
    syncNow: '立即同步',
    viewLogs: '查看日志',
    statusSyncing: '同步中',
    statusSuccess: '已同步',
    statusPartial: '部分成功',
    statusFailed: '同步失败',
    statusPending: '待同步',
    triggerSuccess: '同步已触发',
    logTitle: '同步日志',
    batchId: '批次号',
    status: '状态',
    records: '记录数',
    time: '时间'
  }
}
